export default __webpack_public_path__ + "static/media/4.92d351b7.jpg";